import { PencilIcon } from '@heroicons/react/24/outline';
import { useDispatch } from 'react-redux';

import {
  setSelectedDriverProfile,
  setShowDriverProfileModal,
} from '../team.slice';
import { DriverProfile } from './DriverProfile';

export function DriverProfileRowActions({
  driverProfile,
}: {
  driverProfile: DriverProfile;
}) {
  const dispatch = useDispatch();

  function handleEditDriverProfile() {
    dispatch(
      setSelectedDriverProfile({
        ...driverProfile,
      })
    );
    dispatch(setShowDriverProfileModal(true));
  }
  return (
    <div className="w-[24px]">
      <PencilIcon
        className="cursor-pointer hover:text-mint"
        onClick={() => handleEditDriverProfile()}
      />
    </div>
  );
}
